const Emoji_TUV = {
    ':td': { id: 51, width: 18, height: 18 },
    ':teehee': { id: 512, width: 18, height: 18 },
    ':throb': { id: 513, width: 16, height: 14 },
    ':thumb_yello': { id: 519, width: 27, height: 20 },
    ':thumb': { id: 515, width: 24, height: 17 },
    ':thumbdown': { id: 514, width: 29, height: 20 },
    ':thumbs-up': { id: 516, width: 30, height: 18 },
    ':thumbsdown': { id: 51, width: 18, height: 18 },
    ':thumbsup': { id: 518, width: 38, height: 20 },
    ':thumbup': { id: 517, width: 25, height: 18 },
    ':tired': { id: 47, width: 20, height: 20 },
    ':tongue_ss': { id: 524, width: 20, height: 20 },
    ':tongue': { id: 523, width: 20, height: 20 },
    ':tongue1': { id: 520, width: 18, height: 18 },
    ':tongue2': { id: 521, width: 18, height: 18 },
    ':tongue5': { id: 522, width: 20, height: 20 },
    ':tooth': { id: 525, width: 30, height: 20 },
    ':tounge': { id: 11, width: 18, height: 18 },
    ':toxic': { id: 58, width: 18, height: 18 },
    ':trumpet': { id: 526, width: 35, height: 18 },
    ':tu': { id: 50, width: 18, height: 18 },
    ':turned': { id: 527, width: 18, height: 18 },
    ':tutt': { id: 595, width: 22, height: 18 },
    ':tv': { id: 60, width: 18, height: 18 },
    ':um': { id: 24, width: 18, height: 18 },
    ':umnik': { id: 528, width: 25, height: 19 },
    ':unknw': { id: 529, width: 33, height: 26 },
    ':unlock': { id: 530, width: 32, height: 23 },
    ':unsure': { id: 531, width: 20, height: 20 },
    ':up': { id: 532, width: 15, height: 15 },
    ':vertag': { id: 533, width: 25, height: 26 },
    ':verysad': { id: 534, width: 20, height: 20 },
}

export default Emoji_TUV
